import { defineComponent } from "vue";
import { useLocale } from "../../locales/i18n.js";
import PublicErrorPage from "./PublicErrorPage.js";

export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <PublicErrorPage
                actions={[
                    {
                        icon    : "home",
                        label   : i18n("public.error.404.home"),
                        to      : "/",
                        variant : "primary",
                    },
                    {
                        icon    : "menu_book",
                        label   : i18n("public.error.404.docs"),
                        to      : "/docs",
                        variant : "secondary",
                    },
                ]}
                code="404"
                description={i18n("public.error.404.description")}
                icon="travel_explore"
                kicker={i18n("public.error.404.kicker")}
                title={i18n("public.error.404.title")}
            />
        );
    },
});
